import { c as _c } from "react/compiler-runtime";
import type { BeachSectionFragment } from '@data-access/lib/gql/beach-chairs/documents';
import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents';
import type { HeroImage } from '@shared/utils/hero-image';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { HeroDesktop } from './hero-desktop';
import { HeroMobile } from './hero-mobile';
export type { HeroImage } from '@shared/utils/hero-image';
export interface HeroSectionProps {
  images: HeroImage[];
  /** Overrides the image order on mobile; the desktop grid keeps `images`. */
  mobileImages?: HeroImage[];
  product?: NexperienceFragment | AccommodationFragment | BeachSectionFragment;
}
export function HeroSection(t0) {
  const $ = _c(11);
  let mobileImages;
  let props;
  if ($[0] !== t0) {
    ({
      mobileImages,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = mobileImages;
    $[2] = props;
  } else {
    mobileImages = $[1];
    props = $[2];
  }
  if (props.images?.length === 0) {
    return null;
  }
  const t1 = mobileImages ?? props.images;
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <HeroMobile {...props} images={t1} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props) {
    t3 = <HeroDesktop {...props} />;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}